export enum Environment {
  LOCAL = 'LOCAL',
  DEV = 'DEV',
  DEVINT = 'DEVINT',
  QA = 'QA',
  QAINT = 'QAINT',
  QAINT2 = 'QAINT2',
  PROD = 'PROD',
}

export enum TessEntitlement {
  NASDAPRIV_TESS_SIE = 'nasdPrivTessSie',
  NASDAPRIV_TESS_FINRA = 'nasdPrivTessFinra',
  NASDAPRIV_TESS_MSRB = 'nasdPrivTessMsrb',
  NASDAPRIV_TESS_NASAA = 'nasdPrivTessNasaa',
  NASDAPRIV_TESS_NFA = 'nasdPrivTessNfa',
  NASDAPRIV_TESS_CE = 'nasdPrivTessCe',
}

export var TessEntitlementConfig: Record<TessEntitlement, { urlSuffix: string; label: string }> = {
  [TessEntitlement.NASDAPRIV_TESS_SIE]: {
    urlSuffix: 'SIE',
    label: 'Enroll for the Securities Industry Essentials (SIE)',
  },
  [TessEntitlement.NASDAPRIV_TESS_FINRA]: {
    urlSuffix: 'FINRA',
    label: 'Enroll for Other FINRA Exams',
  },
  [TessEntitlement.NASDAPRIV_TESS_NASAA]: {
    urlSuffix: 'NASAA',
    label: 'Enroll for NASAA Exams',
  },
  [TessEntitlement.NASDAPRIV_TESS_MSRB]: {
    urlSuffix: 'MSRB',
    label: 'Enroll for MSRB Exams',
  },
  [TessEntitlement.NASDAPRIV_TESS_NFA]: {
    urlSuffix: 'NFA',
    label: 'Enroll for NFA Exams',
  },
  [TessEntitlement.NASDAPRIV_TESS_CE]: {
    urlSuffix: 'CE',
    label: 'Enroll for or launch Continuing Education (CE)',
  },
};

export enum VoucherEntitlement {
  NASDAPRIV_VOUCHER = 'nasdPrivVouchFinpro',
}

export var TESS_PARENT_PRIV = 'nasdPrivTessFinpro';

export var VoucherEntitlementConfig: Record<VoucherEntitlement, { urlSuffix: string; label: string }> = {
  [VoucherEntitlement.NASDAPRIV_VOUCHER]: {
    urlSuffix: 'vouchers',
    label: 'Purchase Vouchers',
  },
};

export enum Realm {
  ISSO = 'ISSO',
  EWS = 'EWS',
}
